globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import Title from '../title';
import { SkeletonTextLoading } from '../skeleton-loading';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerStatistic(_ref) {
  var count = _ref.count,
      description = _ref.description,
      label = _ref.label,
      loading = _ref.loading;
  return /*#__PURE__*/_jsxs(StatWrapper, {
    children: [/*#__PURE__*/_jsx(TitlesWrapper, {
      children: loading ? /*#__PURE__*/_jsx(SkeletonTextLoading, {
        width: "small"
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Title, {
          fontWeight: "semibold",
          fontSize: "large",
          textColor: "neutral-700",
          twStyle: {
            "fontSize": "1.125rem",
            "lineHeight": "1.75rem",
            "@media (min-width: 768px)": {
              "fontSize": "1.25rem",
              "lineHeight": "1.75rem"
            }
          },
          children: count === null || count === void 0 ? void 0 : count.toString()
        }), /*#__PURE__*/_jsx(Title, {
          fontWeight: "semibold",
          textColor: "neutral-700",
          fontSize: "small",
          twStyle: {
            "paddingBottom": "3px",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem",
            "textTransform": "lowercase"
          },
          children: label
        })]
      })
    }), loading ? /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "medium"
    }) : /*#__PURE__*/_jsx(Description, {
      children: description
    })]
  });
}
export default EmployerStatistic;

var StatWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-statistic__StatWrapper",
  componentId: "sc-1q76t6e-0"
})(["", ""], {
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem"
});

var TitlesWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-statistic__TitlesWrapper",
  componentId: "sc-1q76t6e-1"
})(["", ""], {
  "marginBottom": "0.25rem",
  "display": "flex",
  "alignItems": "flex-end",
  "gap": "0.5rem"
});

var Description = /*#__PURE__*/_styled.p.withConfig({
  displayName: "employer-statistic__Description",
  componentId: "sc-1q76t6e-2"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});